import { Divider, Segment, Text } from "@simplybusiness/mobius";
import React, { useContext } from "react";
import { CombinedPaymentContext } from "../CombinedPaymentContext";

export const PaymentItemsSection = ({
  headerText,
  headerItem,
  items,
  summaryItems,
  isExternalCarrier = false,
}: PaymentItemsSectionProps) => {
  const isCombinedPaymentPage = useContext(CombinedPaymentContext);
  return (
    <Segment data-testid="payment-items-section">
      <div className="mobius-payment-summary__section-header-text">
        {headerText}
      </div>
      <div className="mobius-payment-summary__section-header">
        {headerItem && !isExternalCarrier && (
          <>
            <Text variant="small" spacing="tight">
              <strong className="mobius-payment-summary__header-label">
                {headerItem.label}
              </strong>
            </Text>
            <Text
              variant="small"
              spacing="tight"
              className="mobius-payment-summary__justified-text"
            >
              <strong className="mobius-payment-summary__header-label">
                {headerItem.value}
              </strong>
            </Text>
          </>
        )}
        {items.map((item, index) => (
          <React.Fragment key={["item", index].join("-")}>
            <div className="mobius-payment-summary__item-grid">
              {item.labels.map(label => (
                <Text variant="small" spacing="tight" key={label}>
                  {label}
                </Text>
              ))}
            </div>
            <Text
              variant="small"
              spacing="tight"
              className="mobius-payment-summary__justified-text"
            >
              {item.value}
            </Text>
          </React.Fragment>
        ))}
      </div>
      {summaryItems && summaryItems.length > 0 && (
        <>
          <Divider
            className={isCombinedPaymentPage ? "combined-styles" : undefined}
          />
          {summaryItems.map((item, index) => (
            <div
              key={`summary-item-${index}`}
              className="mobius-payment-summary__summary-item"
            >
              <Text
                variant="small"
                spacing="tight"
                className={
                  isCombinedPaymentPage
                    ? "mobius-payment-summary__combined-payment-page-text"
                    : "mobius-payment-summary__default-payment-page-text"
                }
              >
                {item.label}
              </Text>
              <Text
                variant="small"
                spacing="tight"
                className={
                  isCombinedPaymentPage
                    ? "mobius-payment-summary__combined-payment-page-text mobius-payment-summary__text-align-right"
                    : "mobius-payment-summary__default-payment-page-text mobius-payment-summary__text-align-right"
                }
              >
                {item.value}
              </Text>
            </div>
          ))}
        </>
      )}
    </Segment>
  );
};

export type PaymentItemsSectionProps = {
  headerText: string;
  headerItem?: {
    label: string;
    value: string;
  };
  items: {
    labels: string[];
    value: string;
  }[];
  summaryItems?: {
    label: string;
    value: string;
  }[];
  isExternalCarrier?: boolean;
};
